import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';

import { ValueBox, ValueGroup, ValueInput } from '@candu-ai/craft/ui';

interface Props {
  label: string | undefined;
  setProps: (props: Record<string, any>) => void;
  inputNamePrefix?: string;
}

export const LabelText = ({ label, setProps, inputNamePrefix = 'form-input' }: Props) => {
  const [inputProps, setInputProps] = useState<{ label?: string }>({ label });

  useEffect(() => {
    setInputProps({ label });
  }, [label]);

  const onInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      setProps({ label: value });
      setInputProps({ label: value });
    },
    [setProps, setInputProps],
  );

  return (
    <ValueGroup>
      <ValueBox label="Label">
        <ValueInput
          value={inputProps.label}
          name={`${inputNamePrefix}-label-value`}
          onChange={onInputChange}
          placeholder="Label"
        />
      </ValueBox>
    </ValueGroup>
  );
};
